import React from 'react'
import * as Scroll from 'react-scroll'
import { GrUp } from 'react-icons/gr'
export default function BackToTop () {
  const scroller = Scroll?.scroller
  return (
    <div className='fixed bottom-12 right-12 z-[50] w-[30px] h-[30px] '>
      <button
        onClick={() =>
          scroller?.scrollTo('main-site-id', {
            duration: 2000,
            delay: 0,
            smooth: true,
            offset: 0
          })
        }
        className='transition-all duration-700 inline-flex absolute rounded-full p-8 items-center justify-center group/spinner z-0 cursor-pointer'
      >
        <GrUp size={'16px'} className='relative z-20' />
        <span className='absolute transition-all duration-500 rounded-full w-[48px] h-[48px] z-10 group-hover/btn:animate-spin-slow border-2 border-dotted border-white group-hover/spinner:border-black'></span>
        <span className='absolute transition-all duration-500 rounded-full group-hover/spinner:w-full group-hover/spinner:h-full w-[32px] h-[32px] z-0 bg-white/50 group-hover/spinner:bg-white'></span>
      </button>
    </div>
  )
}
